import { connect } from 'react-redux';
import {
  setTeamDetails,
  fetchCurrentUser,
} from '../../redux/actions/serverApi.actions';
import FirstTimeExperience from './FirstTimeExperience';
import { State } from '../../redux/configure-store';
import { getLocale } from '../../redux/selectors/config';
import { reportSetUpTeamLoad } from '../../redux/actions/bi.actions';

const mapStateToProps = (state: State) => ({
  currentUser: state.currentUser,
  locale: getLocale(state),
});

const mapDispatchToProps = { setTeamDetails, fetchCurrentUser, reportSetUpTeamLoad };

export const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(FirstTimeExperience);
